import { useCallback, useEffect } from 'react';
import { convertBase64ToFile, convertBlobUrlToDataUrl, getFirebaseUrlsFromFiles, isEmpty } from '../../helpers/common';
import { useMediaRecorder } from '../../hooks/useMediaRecorder';
import { captureException } from '../../services/logService';
import { addShareData, dispatchProjectError } from '../../services/projectServices';
import { SHARE_TYPE } from '../../global/constants';
import { rootStore } from '../../mobx/rootStore';

function Recording({
  setLoading,
  uploadSnapEmbed
}: {
  setLoading: Function;
  uploadSnapEmbed?: (url: string, fileName: string, videoId: string) => void;
}) {
  const { mediaBlobUrl, clearBlobUrl } = useMediaRecorder();

  //mobx variables
  const { projectStore } = rootStore;
  const { currentProject } = projectStore;

  const onScreenCaptureComplete = useCallback(
    async (mediaBlobUrl: string | null) => {
      try {
        if (!mediaBlobUrl) return;
        setLoading(true);
        const baseFile = await convertBlobUrlToDataUrl(mediaBlobUrl)
          .then((regularUrl) => {
            return regularUrl;
          })
          .catch((error) => {
            captureException(error);
          });

        const fileData: File | undefined = await convertBase64ToFile(baseFile, true);
        if (!fileData) {
          dispatchProjectError('There was a problem processing your recording. Please try again.');
          return false;
        }
        if (fileData.size > 2.5e8) {
          dispatchProjectError('Please upload a file smaller than 250 MB.');
          return false;
        }
        const firebaseUrl = await getFirebaseUrlsFromFiles([{ file: fileData }], 'screen_recordings/');
        if (firebaseUrl) {
          const sharePayload = {
            ref: firebaseUrl,
            type: SHARE_TYPE.snap
          };
          const shareResponse = await addShareData(sharePayload);
          const snapUrl = `https://share.teamcamp.app/${shareResponse?.id}`;
          rootStore.appStore.setScreenRecordingUrl(snapUrl || '');
          const fileName = fileData?.name;

          if (uploadSnapEmbed) uploadSnapEmbed(firebaseUrl[0] || '', fileName, shareResponse?.id);
        }
      } catch (e) {
        captureException(e);
      } finally {
        clearBlobUrl();
        setLoading(false);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [currentProject?.id, setLoading]
  );

  useEffect(() => {
    if (!isEmpty(mediaBlobUrl)) onScreenCaptureComplete(mediaBlobUrl);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mediaBlobUrl]);

  return <></>;
}

export default Recording;
